import { z } from 'zod';

/**
 * Zod-схемы контракта настроек уведомлений (work-024 под-этап D, ВЛ-1).
 *
 * GET /me/notifications  → MeNotificationsResponse
 * PATCH /me/notifications ← UpdateNotificationsBody → MeNotificationsResponse
 */

/** Ответ GET/PATCH /me/notifications. */
export const MeNotificationsResponse = z
  .object({
    enabled: z.boolean(),
  })
  .strict();
export type MeNotificationsResponse = z.infer<typeof MeNotificationsResponse>;

/** Тело PATCH /me/notifications. */
export const UpdateNotificationsBody = z
  .object({
    enabled: z.boolean(),
  })
  .strict();
export type UpdateNotificationsBody = z.infer<typeof UpdateNotificationsBody>;
